import { setConfigBgColorClass, setVerticalSpacing } from '../../../utils/layout-util'

export function articleInnerConstrainedClasses(
  layoutConfigs: { columnSize?: string } = {}
): string {
  if (layoutConfigs.columnSize) {
    if (layoutConfigs.columnSize == 'customConstrainedRight') {
      return 'u-sizeConstrainedRight u-md-marginRight0 u-sm-marginRight0'
    } else if (layoutConfigs.columnSize == 'customConstrainedLeft') {
      return 'u-sizeConstrainedLeft'
    } else {
      return 'u-sizeConstrained'
    }
  } else {
    return 'u-sizeConstrained'
  }
}

export function articleInnerVertPadding(
  layoutConfigs: {
    columnSize?: string
    globalBgColor?: { color?: string }
    innerVerticalSpacing?: string
  } = {}
): string {
  if (setConfigBgColorClass(layoutConfigs)) {
    if (layoutConfigs.columnSize) {
      if (
        layoutConfigs.columnSize == 'customConstrainedRight' ||
        layoutConfigs.columnSize == 'customConstrainedLeft'
      ) {
        return 'u-paddingVert0'
      } else if (layoutConfigs.innerVerticalSpacing) {
        return setVerticalSpacing(layoutConfigs.innerVerticalSpacing)
      } else {
        return 'u-paddingVert48'
      }
    } else {
      if (layoutConfigs?.globalBgColor?.color !== 'white') {
        return 'u-paddingVert48'
      }
      return ''
    }
  } else {
    return ''
  }
}

export function setArticleLayoutSize(layoutConfigs: { columnSize?: string } = {}): string {
  let size
  if (layoutConfigs.columnSize) {
    size = 'u-size' + layoutConfigs.columnSize + ' u-sm-sizeFull u-marginCenter'
  } else {
    size = 'u-size10of12 u-lg-before1of12 u-md-before1of12 u-sm-sizeFull'
  }
  return size
}
